import { Drawer } from 'antd';
import { X } from 'lucide-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { TenantLogo } from '../organization/TenantLogo';
import { SidebarFooter } from './SidebarFooter';
import { SidebarNav } from './SidebarNav';

interface MobileNavProps {
  open: boolean;
  onClose: () => void;
}

/** The office nav on phones: a drawer from the left with the full, expanded sidebar. Closes on navigation, backdrop tap or Escape. */
export function MobileNav({ open, onClose }: MobileNavProps) {
  const { pathname } = useLocation();

  // A tapped link has done its job once the route changes.
  useEffect(() => onClose(), [pathname, onClose]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="left"
      size={288}
      closable={false}
      aria-label="Office navigation"
      classNames={{ section: 'bg-sider!', body: 'flex! flex-col p-0!' }}
    >
      <div className="flex h-14 shrink-0 items-center justify-between pr-2.5 pl-5">
        <TenantLogo size="sidebar" />
        <button
          type="button"
          aria-label="Close navigation"
          onClick={onClose}
          className="grid size-10 place-items-center rounded-md text-muted transition-colors hover:bg-sider-selected hover:text-fg"
        >
          <X className="size-5" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto py-3">
        <SidebarNav collapsed={false} touch />
      </div>
      <SidebarFooter collapsed={false} />
    </Drawer>
  );
}
